module.exports = __webpack_public_path__ + "assets/img/title-55257686.png";